import { observable, makeObservable, computed } from 'mobx';

import { MostPopularData, ServiceData, ServiceQuery } from 'chaika-frontend-types/frontend-cms';

import { SearchList } from '@store/abstract/SearchList';
import { ServiceList } from '@services/store/models/ServiceList';

export class MostPopular {
    @observable public isMedicalCaseNameListDataSet = false;

    @observable public referralServiceList = new SearchList<ServiceData, ServiceData, ServiceQuery>(ServiceList);
    @observable public renderedServiceServiceList = new SearchList<ServiceData, ServiceData, ServiceQuery>(ServiceList);
    @observable public medicalCaseNameList = new Map<string, MostPopularData>();

    constructor() {
        makeObservable(this);
    }

    @computed
    public get sortedMedicalCaseNameIds(): string[] {
        return Array.from(this.medicalCaseNameList.values())
            .slice()
            .sort((a, b) => b.requestCount - a.requestCount)
            .map(item => item.entityId);
    }
}
